var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6743 13.075C48.6493 12.675 44.6242 12.375 40.5742 12.15V12.125L40.0243 8.875C39.6493 6.575 39.0992 3.125 33.2492 3.125H26.6992C20.8742 3.125 20.3242 6.425 19.9242 8.85L19.3992 12.05C17.0742 12.2 14.7492 12.35 12.4242 12.575L7.32417 13.075C6.27417 13.175 5.52417 14.1 5.62417 15.125C5.72417 16.15 6.62417 16.9 7.67417 16.8L12.7742 16.3C25.8742 15 39.0743 15.5 52.3243 16.825C52.3993 16.825 52.4493 16.825 52.5243 16.825C53.4743 16.825 54.2993 16.1 54.3993 15.125C54.4743 14.1 53.7243 13.175 52.6743 13.075Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0742 20.35C47.4742 19.725 46.6493 19.375 45.7992 19.375H14.1994C13.3494 19.375 12.4994 19.725 11.9244 20.35C11.3494 20.975 11.0244 21.825 11.0744 22.7L12.6244 48.35C12.8994 52.15 13.2494 56.9 21.9744 56.9H38.0242C46.7492 56.9 47.0995 52.175 47.3742 48.35L48.9242 22.725C48.9742 21.825 48.6492 20.975 48.0742 20.35ZM34.1492 44.375H25.8243C24.7994 44.375 23.9494 43.525 23.9494 42.5C23.9494 41.475 24.7994 40.625 25.8243 40.625H34.1492C35.1742 40.625 36.0242 41.475 36.0242 42.5C36.0242 43.525 35.1742 44.375 34.1492 44.375ZM36.2492 34.375H23.7494C22.7244 34.375 21.8744 33.525 21.8744 32.5C21.8744 31.475 22.7244 30.625 23.7494 30.625H36.2492C37.2742 30.625 38.1242 31.475 38.1242 32.5C38.1242 33.525 37.2742 34.375 36.2492 34.375Z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.c60db07b0c169b2416f42be9d953c5da.svg";
export { ForwardRef as ReactComponent };